export const PRAYER = 1
export const STORY = 2
export const IDEA = 3
